import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TableState } from 'react-table';

type PersistedReduxTable = {
    name: string;
} & Partial<TableState<any>>;

const initialState: { [key: string]: PersistedReduxTable } = {};

const tablesSlice = createSlice({
    name: 'tables',
    initialState,
    reducers: {
        setInitialTableState(state, action: PayloadAction<PersistedReduxTable>) {
            state[action.payload.name] = action.payload;
        }
    }
});

export const { setInitialTableState } = tablesSlice.actions;
export default tablesSlice.reducer;
